import { Component, inject } from '@angular/core';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';

import { TAAS_MENU_ITEM_LIST_TS } from './taas-menuitems';
import { TaasUserService } from './core/services/taas-user-service.service';
import { TaasMenuItem } from 'utimaco-common-ui-angular';
import { TaasMainLayoutComponent, TaasHiddenVersionInfoComponent, TaasToastrComponent } from 'utimaco-common-ui-angular';
import { KeycloakService } from 'keycloak-angular';

import { environment } from '../environments/environment';
import appPackageJson from '../../package.json';
import commonUiPackageJson from 'utimaco-common-ui-angular/package.json';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [TaasMainLayoutComponent, TaasHiddenVersionInfoComponent, RouterOutlet, TaasToastrComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})

export class AppComponent {
  private keycloakService: KeycloakService = inject(KeycloakService);

  constructor(public taasUserService: TaasUserService, private router: Router) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.activeRoute = event.url;
      }
    });

    // trigger loading / updating of current user details object in TaasUserService
    taasUserService.getCurrentUserDetails();
  }

  activeRoute: string = "/";
  taasMenuItemsTs: TaasMenuItem[] = TAAS_MENU_ITEM_LIST_TS;
  commonUiLibVersion: string = commonUiPackageJson.version;
  appVersion: string = appPackageJson.version;

  handleRouteUpdateRequest(path: string) {
    this.router.navigateByUrl(path);
  }

  navigateHome() {
    window.open(environment.taasPortalFrontendUrl);
  }

  performLogout() {
    this.keycloakService?.logout();
  }

  handleUserContextMenuEvent(event: string) {
    switch (event) {
      case "logout":
        this.performLogout();
        break;
      case "showOwnProfile":
        console.log("TODO: show own profile");
        break;
      default:
        console.log("Unsupported user info context event received: ", event);
        break;
    }
  }
}
